import { AxiosResponse } from 'axios';

import API from './api';

import { IAPI } from './IAPI';
import notification from 'antd/es/notification';

const PowerBIAPI = (baseUrl: IAPI) => {
	const api = API(baseUrl);

    const getBIToken = () => {
        const serviceUrl = '/api/v1/Masters/getAccessTokenSilently';
        return api.get(serviceUrl)
            .then((response: AxiosResponse) => response.data)
            .catch((error) => notification.error({
                message: 'Error',
                description: `Failed to fetch Power BI token: ${error.message}`,
            }));
    };

    return {
        getBIToken
    };
};

export default PowerBIAPI;